import React from "react";
import { Link } from "react-router-dom";

// Icons & Images
import EyeIcon from "../../../asset/images/home/icon/fi-rr-eye.png";
import Student1 from "../../../asset/images/home/modules/1.png";
import Student2 from "../../../asset/images/home/modules/2.png";
import Student3 from "../../../asset/images/home/modules/3.png";
import Student4 from "../../../asset/images/home/modules/4.png";
import Student5 from "../../../asset/images/home/modules/5.png";

const CardVowelSee = () => {
    const vowels = [
        { letter: "a", bg: "#1A588B" },
        { letter: "e", bg: "#D5B641" },
        { letter: "i", bg: "#439D55" },
        { letter: "o", bg: "#E14942" },
        { letter: "u", bg: "#374957" },
    ];

    return (
        <div className="flex justify-center items-center min-h-screen">
            <main className="bg-white p-6 sm:p-8 w-full max-w-7xl">

                <h3 className="text-2xl sm:text-3xl font-bold mb-4 text-gray-700">
                    Lesson 13: Decoding Multi-Syllabic words
                </h3>

                <h3 className="text-lg sm:text-xl font-bold text-gray-700 mb-3">
                    Virtual Class Demo
                </h3>

                {/* Description Box */}
                <div className="border-l-2 border-gray-300 pl-4 text-gray-800 leading-relaxed mb-6 sm:text-left">
                    <p className="ml-2">
                        that you’ve learned how to teach students to learn the sounds of the
                        alphabet, let’s take this further by demonstrating with A.I. students.
                        These are compliant students that will repeat whatever you say. There
                        is an expectation for a correct response from you.
                    </p>
                </div>

                {/* See Button */}
                <div className="flex justify-center mt-5 mb-5">
                    <button className="py-3 rounded-full bg-[#E2F2FF] hover:bg-[#c6e1f7] text-gray-700 font-medium mr-3 px-32 flex items-center justify-center">
                        <img src={EyeIcon} height="20" width="20" className="mr-2" alt="" />
                        See
                    </button>
                </div>

                {/* Students Row */}
                <div className="flex justify-center gap-2 flex-wrap bg-[#E2F2FF] py-6 rounded-xl mb-8">
                    <img src={Student1} className="w-50 h-50 object-cover" alt="" />
                    <img src={Student2} className="w-50 h-50 object-cover" alt="" />
                    <img src={Student3} className="w-50 h-50 object-cover" alt="" />
                    <img src={Student4} className="w-50 h-50 object-cover" alt="" />
                    <img src={Student5} className="w-50 h-50 object-cover" alt="" />
                </div>

                {/* Card Section */}
                <div className="max-w-7xl mx-auto">
                    <div className="bg-white border border-primary rounded-xl py-16 shadow-lg">

                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

                            {/* Card Design Left */}
                            <div className="flex justify-center">
                                <div className="relative w-40 h-40">
                                    <div className="absolute right-6 w-40 h-40 bg-[#FFFFFF] rounded-2xl border border-gray-200 shadow-xl"></div>
                                    <div className="absolute right-3 w-40 h-40 bg-[#FFFFFF] rounded-2xl border border-gray-200"></div>

                                    <div className="relative w-40 h-40 bg-[#FFFFFF] rounded-2xl border border-gray-200 flex items-center justify-center text-4xl font-bold text-gray-800 shadow-xl">
                                        Aa
                                    </div>
                                </div>
                            </div>

                            {/* Right Text */}
                            <div className="p-3 text-center items-center justify-center">
                                <h4 className="text-4xl font-semibold text-gray-700">Click on the card</h4>
                                <p className="text-gray-500 text-sm mt-3">Let's get ready</p>
                            </div>

                        </div>

                        {/* Vowel Buttons */}
                        <div className="text-center lg:mt-10 mt-6">
                            <div className="flex flex-wrap justify-center items-center gap-4 sm:gap-6">
                                {vowels.map((v, index) => (
                                    <div key={index}>
                                        <button
                                            className="letter-btn text-white w-20 h-20 sm:w-12 sm:h-12 md:w-20 md:h-20
                        rounded-lg transition-all duration-200 hover:-translate-y-1 flex items-center justify-center
                        text-base sm:text-lg md:text-5xl opacity-50"
                                            style={{ backgroundColor: v.bg }}
                                        >
                                            {v.letter}
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>

                {/* Navigation Button */}
                <div className="flex justify-center mt-5">
                    <Link to="/dashboard/modules/card-vowel-hear">
                        <button className="px-6 py-3 rounded-full bg-green hover:bg-greenDark text-white font-medium">
                            Next →
                        </button>
                    </Link>
                </div>

            </main>
        </div>
    );
};

export default CardVowelSee;
